import ImageGallery from "../components/ImageGallery";

import React from "react";

const Gallery = () => {
  return (
    <div>
      <ImageGallery />
    </div>
  );
};

export default Gallery;
